export default "__VITE_ASSET__B$q0O3Jv__"